import { render, staticRenderFns } from "./CasoTimeline.vue?vue&type=template&id=3ea36cd6&scoped=true&"
import script from "./CasoTimeline.vue?vue&type=script&lang=js&"
export * from "./CasoTimeline.vue?vue&type=script&lang=js&"
import style0 from "./CasoTimeline.vue?vue&type=style&index=0&id=3ea36cd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea36cd6",
  null
  
)

export default component.exports